// AUTO-GENERATED from `aspen_large.json` — do not edit by hand. Regenerate via the preset
//   → `.ts` conversion script when the upstream preset JSONs change.
import type {DeepPartial, TreeOptions} from "../options.js";

const options: DeepPartial<TreeOptions> = {
    "seed": 30631,
    "type": "deciduous",
    "bark": {
      "type": "Bark002",
      "tint": 16777215,
      "flatShading": false,
      "textured": true,
      "textureScale": {
        "x": 1,
        "y": 1
      }
    },
    "branch": {
      "levels": 2,
      "angle": {
        "1": 47,
        "2": 63,
        "3": 7
      },
      "children": {
        "0": 10,
        "1": 6,
        "2": 0
      },
      "force": {
        "direction": {
          "x": 0,
          "y": 1,
          "z": 0
        },
        "strength": 0.021739130434782622
      },
      "gnarliness": {
        "0": 0.05,
        "1": -0.030000000000000006,
        "2": 0.12,
        "3": 0.02
      },
      "length": {
        "0": 69.60000000000001,
        "1": 18.56,
        "2": 11.19,
        "3": 1
      },
      "radius": {
        "0": 1.11,
        "1": 0.5800000000000001,
        "2": 0.7,
        "3": 0.7
      },
      "sections": {
        "0": 12,
        "1": 10,
        "2": 8,
        "3": 6
      },
      "segments": {
        "0": 8,
        "1": 6,
        "2": 4,
        "3": 3
      },
      "start": {
        "1": 0.62,
        "2": 0.049999999999999975,
        "3": 0
      },
      "taper": {
        "0": 0.7000000000000001,
        "1": 0.13,
        "2": 0.7,
        "3": 0.7
      },
      "twist": {
        "0": 0,
        "1": 0,
        "2": 0,
        "3": 0
      }
    },
    "leaves": {
      "type": "aspen",
      "billboard": "double",
      "angle": 36,
      "count": 20,
      "start": 0.15217391304347827,
      "size": 3.4782608695652173,
      "sizeVariance": 0.7,
      "tint": 16580390,
      "alphaTest": 0.5
    },
    "trellis": {
      "enabled": false
    }
  };

export default options;
